//
export default [
    {
        field           : 'Global',
        type            : 'section',
    },
    // {
    //     field           : 'wh_subfamily_id',
    //     type            : 'autocompleteObject',
    //     vuetifyProps    : {
    //         label       : 'Unidad de medida',
    //         noDataText  : '¡ Subfamilias No encontradas!' 
    //     },
    //     options         : {
    //         data        : [],
    //         text        : 'name',
    //         value       : 'id',
    //     },
    //     rules           : [ 'required' ],
    //     value           : '',
    // },
    // {
    //     field           : 'name',
    //     type            : 'text',
    //     vuetifyProps    : {
    //         label       : 'Cantidad minima',
    //     },
    //     rules           : [ 'required', 'numeric' ],
    // },
    {
        field: 'is_repackaged',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Producto Envasado',
        },
        value: false,
    },
    {
        field: 'is_seasonal',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Producto temporada',
            'false-value': false,
        },
        value: false,
    },
    // {
    //     field: 'is_inventoriable',
    //     type: 'checkbox',
    //     vuetifyProps: {
    //         label: 'Producto Inventariable',
    //         'false-value': false,
    //     },
    //     value: false,
    // },
    // {
    //     field: 'have_decimal_quantity',
    //     type: 'checkbox',
    //     vuetifyProps: {
    //         label: 'Cantidad decimal',
    //     },
    //     value: false,
    // },
]